<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :class="{ hideButton: isDisabled }"
    :width="width"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="120px"
        :model="dataForm"
        :rules="editFormRules"
        :disabled="isDisabled"
      >
        <el-form-item label="项目编号：" prop="ProjectCode">
          <p>{{ dataForm.ProjectCode }}</p>
        </el-form-item>
        <el-form-item label="项目名称：" prop="ProjectName">
          <el-input
            placeholder="请输入项目名称"
            v-model="dataForm.ProjectName"
            clearable
            maxlength="100"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="是否求助项目：" prop="IsHelp">
          <el-radio-group v-model="dataForm.IsHelp">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="求助类型：" prop="HelpType" v-if="dataForm.IsHelp==true">
          <el-select v-model="dataForm.HelpType" placeholder="请选择">
            <el-option
              v-for="item in helpTypeOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="是否接受捐赠：" prop="IsDonation">
          <el-radio-group v-model="dataForm.IsDonation">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="项目类型：" prop="ProjectType">
          <el-select v-model="dataForm.ProjectType" placeholder="请选择">
            <el-option
              v-for="item in ProjectTypeOption"
              :key="item.id"
              :label="item.text"
              :value="item.text"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目归属：" prop="TeamName">
          <el-select v-model="dataForm.TeamName" placeholder="请选择">
            <el-option
              v-for="item in ProjectOption"
              :key="item.Id"
              :label="item.Name"
              :value="item.Name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目截止时间：" prop="EndTime">
          <el-date-picker
            v-model="dataForm.EndTime"
            type="date"
            value-format="timestamp"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="封面图：" prop="CoverMap">
          <p>支持png/jpg/jpeg格式，建议尺寸590*360</p>
          <of-upload
            class="upload-demo"
            list-type="picture-card"
            @onPreview="onPreview"
            @onRemove="onRemove"
            @onUpLoad="onUpLoad"
            @onExceed="onExceed"
            :limit="1"
            :fileList="pictureList"
            :class="{ hide: hideUploadEdit }"
            accept="image/jpeg, image/gif, image/png, image/jpg"
          >
            <div slot="content">
              <i slot="default" class="el-icon-plus"></i>
            </div>
          </of-upload>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item label="附件：" prop="File">
          <el-upload
            class="upload-demo upload-demo-file"
            drag
            action="/api/File/FileUpload"
            multiple
            :on-success="onFileUpdate"
            :on-remove="OnFileRemove"
            :on-preview="onFilePreview"
            :file-list="fileList"
            accept=".xls, .doc, .ppt, .xlsx, .docx, .pptx, .txt, .pdf, .zip, .rar"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              支持扩展名：.rar .zip .doc .docx .pdf .jpg...
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="摘要：" prop="Abstract">
          <el-input
            placeholder="请输入项目摘要"
            v-model="dataForm.Abstract"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="项目介绍：" prop="Describe">
          <of-tinymce
            ref="editor"
            v-model="dataForm.Describe"
            :height="500"
            :isEdit="isDisabled"
          ></of-tinymce>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import OfTinymce from "@/components/controls/of_editor/of_tinymce";
import api from "@/modules/zjrc/api";
import { saveAs } from "file-saver";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null
    },
    formTitle: {
      type: String,
      default: ""
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    //验证截止时间
    // var checkEndTime = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error("请选择截止时间"));
    //   }
    //   let now = new Date().getTime();
    //   if (value < now) {
    //     return callback(new Error("无效截止时间"));
    //   }
    //   callback();
    // };
    return {
      //表单规则
      editFormRules: {
        ProjectName: [
          {
            required: true,
            message: "内容标题不能为空",
            trigger: "blur"
          },
          {
            max: 25,
            message: "长度在25个字符以内",
            trigger: "blur"
          }
        ],
        TeamName: [
          {
            required: true,
            message: "项目归属不能为空",
            trigger: "blur"
          }
        ],
        Describe: [
          { required: true, message: "项目介绍不能为空", trigger: "blur" }
        ],
        CoverMap: [
          { required: true, message: "封面图不能为空", trigger: "blur" }
        ],
        ProjectType: [
          { required: true, message: "项目类型不能为空", trigger: "blur" }
        ],
        IsHelp: [
          { required: true, message: "请选择是否求助项目", trigger: "blur" }
        ],
        IsDonation: [
          { required: true, message: "请选择是否接受捐赠", trigger: "blur" }
        ],
        Abstract: [
          {
            max: 50,
            message: "长度在50个字符以内",
            trigger: "blur"
          }
        ]
      },
      isConfirm: false,
      pictureList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      limitNum: 1,
      isdisabled: false,
      hideUploadEdit: false,
      ProjectOption: [],
      itemkey: "OF.RC.ProjectType",
      ProjectTypeOption: [],
      width:"80%",
      helpTypeOption:[
        {value:1,label:"大病求助"},
        {value:2,label:"小天使基金"},
        {value:3,label:"贫困家庭先天性心脏病一心公益基金救助"},
        {value:4,label:"贫困家庭先天性心脏病李家杰珍惜生命基金救助"},
      ],
      fileList:[]
    };
  },
  mounted() {
    // if(!this.dataForm.Id){
    //   this.dataForm.IsHelp=false;
    //   this.dataForm.IsDonation=true;
    // }
    this.getImg();
    this.getProjectTypeOption();
    this.getProjectOption();
    this.getfile();
  },
  components: {
    OfDialog,
    OfUpload,
    OfTinymce
  },
  methods: {
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //保存&更新
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.isConfirm = true;
          let params = Object.assign({}, this.dataForm);
          params.EndTime = params.EndTime / 1000;
          params.Status = 0;
          params.CreateTime = 0;
          this.ProjectOption.forEach(item => {
            if (item.Name == params.TeamName) {
              params.TeamId = item.Id;
              return;
            }
          });
          api.SavePublicWelfare(params)
            .then(rep => {
              this.isConfirm = false;
              if (rep.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success"
                });
                this.$emit("formCallBack", params);
              } else {
                this.$message({
                  message: rep.data.Message,
                  type: "error"
                });
              }
            })
            .catch(e => {
              this.isConfirm = false;
              this.$message({
                message: e.toString(),
                type: "error"
              });
            });
        }
      });
    },
    //删除封面图
    onRemove() {
      this.pictureList = [];
      this.dataForm.CoverMap = null;
      this.hideUploadEdit = false;
    },
    //查看图片
    onPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //上传封面图
    onUpLoad(file) {
      if (file.response.Code === 0) {
        const obj = {fileId: file.response.Data.FileId,url: '/files' + file.response.Data.StorePath,name: file.response.Data.FullName}
        this.dataForm.CoverMap = JSON.stringify(obj)
        this.$message({
          message: "封面图上传成功",
          type: "success"
        });
        this.hideUploadEdit = true;
      }
    },
    onExceed() {
      this.$message({
        message: `只能选择 ${this.limitNum} 个文件`,
        type: "error"
      });
    },
    getImg() {
      const vm = this
      if (
        vm.dataForm.CoverMap === undefined ||
        vm.dataForm.CoverMap === null ||
        vm.dataForm.CoverMap == ""
      ) {
        return;
      }
      vm.hideUploadEdit = true;
      const obj = JSON.parse(this.dataForm.CoverMap)
      vm.pictureList.push(obj)

    },
    //获取字典中项目类型
    getProjectTypeOption() {
        let params={itemKey:this.itemkey}
      api.QueryProjectType(params).then(rep => {
        if (rep.data.Code === 0) {
          this.ProjectTypeOption = rep.data.Data;
        }
      });
    },
    getProjectOption() {
      api.QueryConnectionName().then(rep => {
        if (rep.data.Code === 0) {
          this.ProjectOption = rep.data.Data;
        }
      });
    },
    //初始化附件
    getfile() {
      let that = this;
      if (that.dataForm.File || that.dataForm.File != null) {
        let params = { Id: that.dataForm.File };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.fileList.push({
                url: item.Url,
                name: item.FileName,
                response: response,
              });
            });
          }
        });
      }
    },
    //附件上传
    onFileUpdate(rtnResult) {
      let that = this;
      if (rtnResult.Code == 0) {
        if (!that.dataForm.File && !that.dataForm.File) {
          that.dataForm.File = rtnResult.Data.FileId;
        } else {
          that.dataForm.File += "," + rtnResult.Data.FileId;
        }
        that.$message({
          message: "附件上传成功",
          type: "success",
        });
      }
    },
    //附件删除
    OnFileRemove(file, fileList) {
      let that = this;
      that.dataForm.File = "";
      fileList.forEach((item) => {
        if (that.dataForm.File == "") {
          that.dataForm.File = item.response.Data.FileId;
        } else {
          that.dataForm.File += "," + item.response.Data.FileId;
        }
      });
    },
    //附件下载
    onFilePreview(file) {
      saveAs("/api/File/Download?Id=" + file.response.Data.FileId, file.name);
    },
  }
};
</script>


<style scoped>
.el-textarea > textarea {
  height: 80px;
}

.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-date-editor >>> .el-input__inner {
  width: 90%;
}
.upload-demo-file >>> .el-upload-dragger {
  width: 270px;
  height: 120px;
}
.upload-demo-file >>> .el-icon-upload {
  margin: 10px 0 16px;
}
</style>

<style>
.hide {
  display: block !important;
}

.hideFile .el-upload--fileList {
  display: none;
}

.hideButton .el-button--primary {
  display: none;
}
</style>
